import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

const FILTER_PAG_REGEX = /[^0-9]/g;

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input() totalCount;
  @Input() pageSize = 10;
  @Input() paginatorSize = 5;
  @Input() page = 1;
  @Input() showInfo = false;
  @Output() pageChangeEvent = new EventEmitter<number>();
  constructor() { }

  /**
   * OnInit Lifecycle hook
   */
  ngOnInit() {
  }

  /**
   * Track page number input
   */
  ngOnChanges(changes) {
    if (changes && changes.page && changes.page.currentValue) {
      this.page = changes.page.currentValue;
    }
  }
  /**
   * Go to selected page
   * @param page page no.
   */
  selectPage(page: number) {
    this.page = page || 1;
    this.pageChangeEvent.emit(this.page);
  }
  /**
   * Format number
   */
  formatInput(input: HTMLInputElement) {
    input.value = input.value.replace(FILTER_PAG_REGEX, '');
  }

}
